import React from "react";
import FilestackUploader from "../../common/filestack_uploader/main";
import Blitline from "../../../helpers/blitline";
import Editor from "../editor/main";
import "./styles/workbench_uploader";

export default class Uploader extends React.Component {
  constructor(...args) {
    super(...args);
    this.addFile        = this.addFile.bind(this);
    this.handleError    = this.handleError.bind(this);
    this.resetUploader  = this.resetUploader.bind(this);
    this.state = {
      filetype: null,
      filetype_supported: true,
      filestack_url: null
    };
  }

  resetUploader() {
    this.setState({
      filetype: null,
      filetype_supported: true,
      filestack_url: null
    });
  }

  addFile(files) {
    let file = files.filesUploaded[0];
    let filetype = Blitline.normalizeFiletype(file.mimetype.split("/")[1]);
    if (Blitline.hasSupportFor(filetype)) {
      this.setState({ filestack_url: file.url });
    } else {
      this.setState({ filetype, filetype_supported: false });
    }
  }

  handleError(file, error) {
    console.log(error);
    this.setState({ error: true })
  }

  renderUploadArea() {
    if (!this.state.filetype_supported) {
      return (
        <div className="filetype-not-supported">
          <p>
            Sorry, editing of <span>{this.state.filetype}</span> files is not
            currently supported.
          </p>
          <input
            type="submit"
            value="Upload A Different File"
            onClick={this.resetUploader}
          />
        </div>
      );
    } else {
      return (
        <div className="workbench-upload-area">
          <FilestackUploader
            type="area"
            options={{ maxFiles: 1 }}
            onSuccess={this.addFile}
            onError={this.handleError}
          />
        </div>
      );
    }
  }

  render() {
    let { filestack_url } = this.state;
    if (!!filestack_url) {
      return <Editor filestack_url={filestack_url} />;
    }
    return (
      <div className='workbench-uploader-component'>
        <div className="workbench-overview">
          <div className="workbench-overview__container">
            <div className="workbench-overview__info">
              <h1>Welcome to Workbench</h1>
              <p>
                Brandfolder offers powerful asset data extraction and editing
                capabilities. While every Brandfolder comes loaded with these
                robust features, we’ve created Workbench so you can try before you
                buy. Upload an asset and see.
              </p>
              {this.renderUploadArea()}
              <h2>Features</h2>
              <div className="workbench-overview__features">
                <ul>
                  <li>
                    Generate an asset color palette with HEX codes you can copy
                    with one click.
                  </li>
                  <li>Extract text from images.</li>
                  <li>
                    Automatically creates tags on upload. Our intelligent,
                    Google-backed API generates the most accurate keywords
                    associated with your asset.
                  </li>
                  <li>
                    Reverse image search: discover where your asset is being used
                    on the web.
                  </li>
                </ul>
                <ul>
                  <li>Extract asset’s metadata upon upload.</li>
                  <li>
                    Resize image to be the exact size you specify, down to the
                    pixel.
                  </li>
                  <li>
                    Convert color modes to prepare asset for varying output
                    formats.
                  </li>
                  <li>
                    Download as an alternate file type. For example, turn an
                    Illustrator file into a PNG.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="workbench-overview__container">
            <div className="workbench-overview__image" />
          </div>
        </div>
      </div>
    );
  }
}
